import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'app-icon-process-draft',
    templateUrl: './icon-process-draft.component.html'
})
export class IconProcessDraftComponent implements OnInit {

    @Input()
    cssClass = '';

    constructor() { }

    ngOnInit() {
    }

}
